import React, { Component } from 'react';
import LayoutHeader from '../Inc/Header';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { Modal , Menu, Button, Row, Col, Input, Form, Icon, message,Card, Upload, notification} from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import * as actions from '../../actions/index';

class AlumniHelpNST extends Component {
  constructor(props){
    super(props)
    this.state = {
      isShowNST_modal: false,
    }
  }

  ShowNST_Modal = () => {
    this.setState({isShowNST_modal: true})
  }
  HideNST_Modal = () => {
      this.setState({isShowNST_modal: false})
  }

  renderNSTPortalModal = () => {
      return <Modal
      className='width-80 directory-help'
      // title="View Membership"
      centered
      // style={{width: '1000px', }}
      visible={this.state.isShowNST_modal}
      onOk={() => this.HideNST_Modal()}
      onCancel={() => this.HideNST_Modal()}
      footer={null}
      >
          <div >
          <iframe style={{width: '100%', height: '600px'}} src='https://d153zqp2yevlxw.cloudfront.net/NST%20ALUMNI%20PORTAL%20SPECIALIST%20(As%20of%20March%2014%202023).pdf' title='NST ALUMNI PORTAL SPECIALISTS' />
          </div>
          
      </Modal>
  }

  static propTypes = {
    location: PropTypes.object.isRequired
  }

  render () {
    const { location } = this.props;
    return (
      <div>
        <LayoutHeader />

        <Menu mode="horizontal" selectedKeys={[location.pathname]} defaultSelectedKeys={['/']} style={{ alignItems: "end", display: "Flex", justifyContent: "end"  }}>
          <Menu.Item key="/alumni-dashboard"> 
            <NavLink to="/alumni-dashboard">
              <button className='Need-help-action'>CLOSE <i class="fa fa-window-close" aria-hidden="true"></i></button>  
            </NavLink>
          </Menu.Item>
        </Menu>

        <div className='Alumni-NeedHelp-Container'>
          <div className='Alumni-NeedHelp-Greeting-NSTPortal'>
            The <Button onClick={() => this.ShowNST_Modal()} type="link" className='Alumni-NeedHelp-Form-Link' > NST Alumni Specialists </Button> represent a group of volunteers who 
            monitor the website for updates and support local users regarding site functionality and alumni information.
          </div>
        </div>

        {this.renderNSTPortalModal()}

      </div>
      
    )
  }
}

function mapStateToProps(state) {
  return {
    isadmin: state.isadminreducer.isadmin,
  }
}

function mapDispatchToProps(dispatch) {
  return {
      actions: bindActionCreators(actions, dispatch)
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(Form.create()(AlumniHelpNST));


// WEBPACK FOOTER //
// ./src/components/AlumniHelp/AlumniHelpNST.js